import { Router } from '@angular/router';
import { catchError, map, tap } from 'rxjs/operators';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ImportService } from '../../../../../ongoing/src/lib/services/import/import.service';
import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';

import { EmployeeItemPreview } from './../../../../../ongoing/src/lib/interfaces/employee.model';
import { SegmentTrackImport } from '@unico-people/shared/enums/utils-enums';
import { environment } from '@unico-people/shared/utils/environments';


@Component({
  selector: 'up-feature-upload-import-files',
  templateUrl: './feature-upload-import-files.component.html',
  styleUrls: ['./feature-upload-import-files.component.scss']
})
export class FeatureUploadImportFilesComponent {
  public readonly collaboratorUrl: string = environment.ongoing_url;

  @Input() customItem: any;
  @Output() childEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() collaborator: EventEmitter<boolean> = new EventEmitter<boolean>();

  preview$: Observable<any>;
  error$ = new Subject<any>();

  fileName: string;
  progress: number;
  uploading: boolean;
  uploadSuccess: boolean;
  logsUrl: string;
  objectID: string;
  hovering = false;

  requestIdPreview: string;
  listEmployeeImport: Array<EmployeeItemPreview>;

  constructor(
    private importService: ImportService,
    private router: Router,
    public snackBar: MatSnackBar,
    private segment: TrackingSegmentService
  ) {}

  ngOnInit(): void {
    this.segment.page(SegmentTrackImport.page_view_import);
  }

  emitterCancel(emitterEvent?: boolean): void {
    this.preview$ = of();
    this.uploading = false;
    this.error$.next(null);
    if (emitterEvent) {
      this.childEmitter.emit(false);
    }
    this.segment.track(SegmentTrackImport.import_send_worksheet_again)
  }

  manuallyUpload(e: any): void {
    this.uploadFile(e.target.files);
  }

  hoveredDropzone(hover: boolean): void {
    this.hovering = hover;
    this.segment.track(SegmentTrackImport.click_button_send_spreadsheet)
  }

  uploadFile(e: FileList): void {
    const file: File = e.item(e.length - 1);
    this.fileName = file.name;
    window.event.preventDefault();

    this.previewDataCollaborator(file);
  }

  previewDataCollaborator(file: File): void {
    this.uploading = true;
    this.preview$ = this.importService.previewImport(file).pipe(
      map(res => res?.body),
      tap(res => !!res ? this.segment.track(SegmentTrackImport.import_done) : null),
      catchError(err => {
        this.error$.next(err);
        this.trackError(err?.error?.code);
        this.trackStatusError(err.status);
        return of();
      })
    );
  }

  trackEvents(type: string): void {
    const trackTypes = {
      import_download: SegmentTrackImport.click_button_download,
      import_send: SegmentTrackImport.click_button_send_spreadsheet,
      invalid_format: SegmentTrackImport.import_invalid_format,
      import_download_after_error: SegmentTrackImport.download_send_worksheet_again
    };
    this.segment.track(trackTypes[type]);
  }

  trackError(error: number): void {
    const trackError = {
      19: SegmentTrackImport.import_invalid_format,
      20: SegmentTrackImport.import_maximum_size,
      21: SegmentTrackImport.import_column_error,
      22: SegmentTrackImport.import_column_error,
      34: SegmentTrackImport.import_column_error,
      35: SegmentTrackImport.import_column_error,

    }
    this.segment.track(trackError[error]);
  }

  trackStatusError(status: number): void {
    const trackStatusError = {
      404: SegmentTrackImport.import_send_failed
    }
    this.segment.track(trackStatusError[status]);
  }
}
